import "./Features.scss";
import FeatureCard from "../../components/Home/FeatureCard";
import LayeredImage from "../../components/shared/LayeredImage";

import GearsMerged from "../../assets/images/gears-merged.png";
import AiAgent from "../../assets/images/ai-agent.png";
import SCM from "../../assets/images/scm.png";
import RelayNetwork from "../../assets/images/relay-network.png";
import GasFeeOptimization from "../../assets/images/gas-fee-optimization.png";
import GatrSwap from "../../assets/images/gatr-swap.png";

export default function Features() {
	return (
		<>
			<div className="features" id="features">
				<div className="features-content-wrapper content-wrapper-lg">
					<h1 className="features-title" data-aos="zoom-in">
						FEATURES
					</h1>

					<div className="features-content">
						<div className="features-content-row">
							<div
								className="col-privacy-engine"
								data-aos="fade-up"
							>
								<FeatureCard className="privacy-engine">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											Gatr Privacy Engine
										</h6>

										<p className="feature-card-description">
											A self-learning, AI-powered core
											that dynamically adapts to counter
											blockchain surveillance, ensuring
											untraceable transactions. It
											fragments, reroutes, and encrypts
											data using zk-SNARKs, preventing
											de-anonymization. With real-time
											threat analysis and autonomous
											updates, Gatr creates a fully
											invisible and untraceable Web3
											ecosystem.
										</p>
									</div>

									<LayeredImage
										width={488}
										height={298}
										className="feature-card-image"
									>
										<img
											className="gears"
											src={GearsMerged}
											alt="Gears"
										/>
									</LayeredImage>
								</FeatureCard>
							</div>
							<div className="col-ai-agent" data-aos="fade-up-right">
								<FeatureCard className="ai-agent">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											Gatr AI Agent
										</h6>

										<p className="feature-card-description">
											Gatr’s AI Agent anticipates threats
											before they emerge, obfuscating
											transactions with rerouting, decoys,
											and smart contract morphing. It also
											optimizes gas fees in real time,
											ensuring unmatched privacy and
											efficiency in Web3.
										</p>
									</div>

									<LayeredImage
										width={676}
										height={524}
										className="feature-card-image"
									>
										<img
											className="ai-agent"
											src={AiAgent}
											alt="AI Agent"
										/>
									</LayeredImage>
								</FeatureCard>
							</div>
							<div className="col-scm" data-aos="fade-up-left">
								<FeatureCard className="scm">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											Smart Contract Morphing
										</h6>

										<p className="feature-card-description">
											Gatr’s AI dynamically fragments
											transactions across multiple wallets
											and contracts, preventing tracking.
											Randomized execution paths,
											AI-powered obfuscation, and split
											trades ensure DeFi swaps, trades,
											and DAO votes remain private and
											untraceable.
										</p>
									</div>

									<LayeredImage
										width={444}
										height={524}
										className="feature-card-image"
									>
										<img
											className="scm"
											src={SCM}
											alt="Smart Contract Morphing"
										/>
									</LayeredImage>
								</FeatureCard>
							</div>
							<div className="col-left">
								<FeatureCard className="relay-network" data-aos="fade-up">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											Gatr Relay Network
										</h6>

										<p className="feature-card-description">
											Gatr’s Relay Network breaks direct
											wallet links by encrypting and
											routing transactions through
											AI-powered relayers. Each relayer
											processes encrypted data without
											knowing the sender, while zk-SNARKs,
											ghost hops, and AI-generated decoys
											prevent tracking. Randomized
											multi-hop routing and time delays
											make tracing impossible, ensuring
											full transaction anonymity.
										</p>
									</div>

									<LayeredImage
										width={444}
										height={812}
										className="feature-card-image"
									>
										<img
											className="relay-network"
											src={RelayNetwork}
											alt="Relay Network"
										/>
									</LayeredImage>
								</FeatureCard>
							</div>
							<div className="col-right">
								<FeatureCard className="gas-fee-optimization" data-aos="fade-down">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											Gas Fee Optimization
										</h6>

										<p className="feature-card-description">
											Gatr’s AI optimizes gas fees by
											intelligently analyzing network
											conditions and dynamically selecting
											the most cost-efficient and private
											route. It fragments transactions,
											utilizes stealth relayers, and
											rotates contract instances to
											prevent tracking while ensuring the
											lowest possible fees and maximum
											anonymity.
										</p>
									</div>

									<LayeredImage
										width={676}
										height={408}
										className="feature-card-image"
									>
										<img
											className="gas-fee-optimization"
											src={GasFeeOptimization}
											alt="Gas Fee Optimization"
										/>
									</LayeredImage>
								</FeatureCard>

								<FeatureCard className="gatr-swap" data-aos="fade-up">
									<div className="feature-card-content">
										<h6 className="feature-card-title">
											GatrSwap
										</h6>

										<p className="feature-card-description">
											GatrSwap ensures untraceable swaps
											by dynamically fragmenting
											transactions across multiple wallets
											and contract instances. Toggle Smart
											Contract Morphing, adjust
											fragmentation settings, and execute
											swaps with AI-randomized execution
											paths. Receive funds with no
											traceable history, even across
											multiple blockchains.
										</p>
									</div>

									<LayeredImage
										width={676}
										height={471}
										className="feature-card-image"
									>
										<img
											className="gatr-swap"
											src={GatrSwap}
											alt="GatrSwap"
										/>
									</LayeredImage>
								</FeatureCard>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
